import { useQuery } from "@tanstack/react-query";

import { getPlatformCurrent } from "api/methods";
import { Models } from "api/types";

type UsePlatformResult = {
  platform?: Models<"PlatformModel">;
};

export const usePlatform = (): UsePlatformResult => {
  const { data } = useQuery({
    ...getPlatformCurrent.keyed(),
    queryFn: () => getPlatformCurrent() as Promise<Models<"PlatformModel">>,
    staleTime: 1000 * 60 * 2,
    // TODO: This query throws errors in anonymous contexts on mobile
    useErrorBoundary: false,
  });

  return { platform: data };
};
